import React from 'react'
import Artists from '../../content/Artists'

const Featured = (props) => {
  return <Artists {...props} title="Featured" />
}

export default Featured
